import { render, staticRenderFns } from "./CompetitorWebsiteRenderer.vue?vue&type=template&id=50be24fe&scoped=true&"
import script from "./CompetitorWebsiteRenderer.vue?vue&type=script&lang=js&"
export * from "./CompetitorWebsiteRenderer.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorWebsiteRenderer.vue?vue&type=style&index=0&id=50be24fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be24fe",
  null
  
)

export default component.exports